import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Icon from '../Icon';

const StyledIcon = styled(Icon)`
  fill: none;
`;

const NotifyMeWhiteIcon = (props) => {
  const { color, ...rest } = props;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StyledIcon width="25" height="24" viewBox="0 0 25 24" {...rest}>
      <path
        d="M12.4995 9.35303L12.5005 13.3547"
        stroke="#3C4852"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.4992 11.3543L14.5008 11.3532"
        stroke="#3C4852"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.009 18.0024V18.5147C10.009 19.8893 11.1234 21.0037 12.498 21.0037H12.5C13.1604 21.004 13.7939 20.7419 14.261 20.2751C14.7282 19.8083 14.9908 19.1751 14.991 18.5147V18.0024"
        stroke="#3C4852"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.4495 18.0023C19.5838 18.0023 20.5033 17.0828 20.5033 15.9485V15.9485C20.5029 15.3723 20.2741 14.8197 19.8671 14.4118L18.5025 13.0483V8.99859C18.5025 5.6835 15.8151 2.99609 12.5 2.99609V2.99609C9.18492 2.99609 6.49751 5.6835 6.49751 8.99859V13.0483L5.13294 14.4118C4.72592 14.8197 4.49713 15.3723 4.49667 15.9485V15.9485C4.49667 16.4932 4.71306 17.0156 5.09823 17.4008C5.48341 17.786 6.00581 18.0023 6.55053 18.0023H18.4495Z"
        stroke="#3C4852"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledIcon>
  );
};

NotifyMeWhiteIcon.propTypes = {
  color: PropTypes.string
};

NotifyMeWhiteIcon.defaultProps = {
  color: 'var(--color-text-primary)'
};

export default NotifyMeWhiteIcon;
